import { ActionClass } from "../../infrastructure";

export class AppActions extends ActionClass {
    public setHorizontalLayout: (horizontal: boolean) => void = null as any;
    public setDrawerOpen: (open: boolean) => void = null as any;
    public setCookieState: (visible: boolean) => void = null as any;
}